import { Box, Link, useTheme } from "@mui/material";
import { useMemo } from "react";
import TextConstants from "src/common/helpers/TextConstants";

/** サイドメニューのヘッダー コンポーネント */
const SideMenuHeader = () => {
    const theme = useTheme();

    const sx = useMemo(() => ({
        display: 'flex',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        alignItems: "center",
        justifyContent: "center",
    }), [theme]);

    return (
        <Box sx={sx}>
            <Link href="/" underline="always">
                {TextConstants.Common.Title}
            </Link>
        </Box>
    );
};

export default SideMenuHeader;
